import { Location } from "@angular/common";
import { Component, OnInit, signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EvaluationService } from "app/services/evaluation/evaluation.service";
import { ImagesService } from "app/services/helper/images.service";
import { PersonService } from "app/services/person/person.service";
import { ProjectService } from "app/services/project/project.service";
import { UserService } from "app/services/user/user.service";
import { Persona } from "app/shared/models/user.interface";

@Component({
    selector: "app-job-section",
    templateUrl: "./job-section.component.html",
    styleUrls: ["./job-section.component.scss"],
    standalone: false
})
export class JobSectionComponent implements OnInit {
    readonly person = signal<Persona | null>(null);
    puesto: string;
    readonly sectionList = signal<Array<any>>([]);
    readonly subsectionList = signal<Array<any>>([]);

    selectedSubsection: number;
    readonly currentJobSections = signal<Array<any>>([]);

    isEvaluator: boolean = true; //TODO

    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private imageSvc: ImagesService,
        private personSvc: PersonService,
        private userSvc: UserService,
        private projectSvc: ProjectService,
        private evaluationSvc: EvaluationService
    ) {
        //Empty
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            this.puesto = params.puesto;
            this.personSvc.getPerson(params.personId).subscribe((data) => {
                this.person.set(data);
            });
            this.personSvc.getJobSections(params.personId).subscribe((data) => {
                this.currentJobSections.set(Array.isArray(data) ? data : []);
            });
        });
        this.evaluationSvc.getJobSections().subscribe((data) => {
            this.sectionList.set(Array.isArray(data) ? data : []);
        });
    }

    getImagePerson(nickname: string) {
        return this.imageSvc.getImageThumb(nickname);
    }

    onChangeSection(parentId) {
        this.evaluationSvc.getJobSubsections(parentId).subscribe((data) => {
            this.subsectionList.set(Array.isArray(data) ? data : []);
        });
    }

    onChangeSubsection(subsection) {
        this.selectedSubsection = subsection;
    }

    addJobSection() {
        if (!this.selectedSubsection) {
            return;
        }
        const p = this.person();
        if (!p) {
            return;
        }
        this.personSvc.addJobSections(p.id, this.selectedSubsection).subscribe((data) => {
            if (data.success) {
                this.personSvc.getJobSections(p.id).subscribe((sections) => {
                    this.currentJobSections.set(Array.isArray(sections) ? sections : []);
                });
            }
        });
    }

    removeJobSection(jobSection) {
        const p = this.person();
        if (!p) {
            return;
        }
        this.personSvc.removeJobSections(p.id, jobSection.subsectionId).subscribe((data) => {
            if (data.success) {
                this.personSvc.getJobSections(p.id).subscribe((sections) => {
                    this.currentJobSections.set(Array.isArray(sections) ? sections : []);
                });
            }
        });
    }

    back() {
        this.location.back();
    }
}
